module.exports = __webpack_public_path__ + "img/EmptyMessages.6a261811.svg";